<div class="row">
  <div class="col-12">
    <div class="input-group-material input-group-right asset-search-default keepcolor">
      <div class="input-group-material-icon text-color-basic">
        <svg class="icon mirror">
          <use xlink:href="/assets/img/svgs/svgset.svg#search" />
        </svg>
      </div>
      <input
        id="typeahead-template"
        class="w-100"
        type="text"
        spellcheck="false"
        autofocus
        [placeholder]="'Betreff'"
        [(ngModel)]="model"
        [ngbTypeahead]="search"
        [resultTemplate]="resultsTemplate"
        (selectItem)="itemSelected($event)"
      />
    </div>
  </div>
</div>

<ng-template #resultsTemplate let-r="result" let-t="term">
  @if (r.title) {
    <div class="d-flex input-group-material-liste-item align-items-center">
      <div class="flex-grow pr-1 overflow-hidden ellipsis">
        <div [innerHTML]="r.title"></div>
      </div>
    </div>
  }
</ng-template>
